import { render } from "./addNote.vue?vue&type=template&id=79208eeb"
import script from "./addNote.vue?vue&type=script&lang=js"
export * from "./addNote.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__